<template>
  <div>
    <van-sticky :offset-top="46">
      <van-dropdown-menu>
        <van-dropdown-item v-model="queryParams.auditStatus" :options="option" @change="handleRefresh"/>
      </van-dropdown-menu>
    </van-sticky>
    <page-list ref='pageList' request-url="/sys/account/store" :getParams="getQueryParams">
      <template #row="{row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-col span="18">账号名称: {{row.accountName}}</van-col>
          <van-col span="6">{{formatAuditStatus(row.auditStatus)}}</van-col>
          <van-col span="24">店铺名称: {{row.storeName}}</van-col>
          <van-col span="12">联系人: {{row.contacts}}</van-col>
          <van-col span="12">联系电话: {{row.phoneNumber}}</van-col>
          <van-col span="24">省市区: {{row.province +',' +row.city+',' +row.area}}</van-col>
          <van-col span="24">详细地址: {{row.address}}</van-col>
          <van-col span ='24' v-if="row.auditStatus === 0">
            <van-row type="flex" justify="center" >
              <van-col span="12"><van-button type="info" size="small" block @click="agreeApply(row.id)">同意</van-button></van-col>
              <van-col span="12"><van-button type="default" size="small" block @click="rejectApply(row.id)">拒绝</van-button></van-col>
           </van-row>
          </van-col>
        </van-row>
      </template>
    </page-list>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'UserStoreList',
  components: { PageList },
  created () {
  },
  data () {
    return {
      subId: null,
      model: {},
      queryParams: {
        auditStatus: -1
      },
      option: [
        { text: '全部店铺', value: -1 },
        { text: '待审核', value: 0 },
        { text: '已审核', value: 1 },
        { text: '已拒绝', value: 2 }
      ]
    }
  },
  computed: {

  },
  methods: {
    formatAuditStatus (status) {
      if (status === 0) {
        return '待审核'
      } else if (status === 1) {
        return '通过'
      } else if (status === 2) {
        return '拒绝'
      }
      return '未知状态'
    },
    getQueryParams (params) {
      const param = Object.assign({}, params)
      if (this.queryParams.auditStatus !== -1) {
        param.auditStatus = this.queryParams.auditStatus
      }
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    },
    agreeApply (id) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否确认同意当前申请?'
      }).then(() => {
        this.changeAuditStatus(id, 1)
      }).catch(() => {

      })
    },
    rejectApply (id) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否确认拒绝当前申请?'
      }).then(() => {
        this.changeAuditStatus(id, 2)
      }).catch(() => {

      })
    },
    changeAuditStatus (id, auditStatus) {
      this.$api.user.approveStore(id, auditStatus).then(response => {
        if (response.success) {
          this.$toast.success('操作成功')
        } else {
          this.$toast.fail(response.message)
        }
        this.handleRefresh()
      }).catch(() => {

      })
    }
  }

}
</script>
